import axios from 'axios';
import {
  GET_SPORTSBOOK_EVENTS_HASH_REQUEST,
  GET_SPORTSBOOK_EVENTS_HASH_SUCCESS,
  GET_SPORTSBOOK_EVENTS_HASH_FAILURE,
  REST_SPORTSBOOK_EVENTS_HASH
} from 'Store/constants';
import { BULLETIN_TYPES } from 'Store/constants/sportTypes';

import { logError } from 'Utils/errorHandler';
import errorMessage from 'Store/actions/errorMessage';
import { createSportsBookGroupsAndFilters } from 'Utils/filterGenerator';
import { getEventScores } from 'Store/actions';
import LocalStorage from '../../../utils/localStorage';
import EnvironmentManager from 'Utils/environmentManager';

let debounceTimer = null;

export const getSportsBookEventsHash = ({
  tabType,
  bulletinType,
  showLoading = true,
  callback,
}) => async dispatch => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  await new Promise(resolve => {
    debounceTimer = setTimeout(resolve, 100);
  });

  try {
    dispatch({
      type: GET_SPORTSBOOK_EVENTS_HASH_REQUEST,
      payload: { showLoading }
    });

    const liveEventsEnabledSwitch = EnvironmentManager.getMessageText({ key: 'live_bet_switch_visibility' }) === 'true';

    const params = {
      tabType: tabType,
      bulletinType: bulletinType
    };

    if (liveEventsEnabledSwitch) {
      params.liveEventsEnabledForPreBulletin = true;
    }

    const res = await axios.get('/v3/mobile/aggregator/gamelist/all/v1', {
      params
    });

    const { eventGroups, onComingEventGroups, definedFilters, availableFilters }
      = createSportsBookGroupsAndFilters({ data: res?.data, tabType });

    dispatch({
      type: GET_SPORTSBOOK_EVENTS_HASH_SUCCESS,
      payload: {
        ...res?.data,
        groupedFilters: definedFilters,
        groupedEvents: eventGroups,
        groupedOnComingEvents: onComingEventGroups,
        availableFilters: availableFilters,
        sportType: tabType,
        bulletinType,
      },
    });

    const events = Object.values(res?.data?.events);
    const isLiveChecked = LocalStorage.get('liveChecked') === true;

    if (bulletinType === BULLETIN_TYPES.LIVE && events?.length > 0) {
      dispatch(getEventScores(events));
    }

    if (bulletinType === BULLETIN_TYPES.PREMATCH && events?.length > 0 && isLiveChecked) {
      const liveEvents = events.filter(event => event?.bf === 1);
      if (liveEvents.length > 0) {
        dispatch(getEventScores(liveEvents));
      }
    } else {
      const liveEventsInPrematch = events.filter(event => event?.bf === 1);
      if (liveEventsInPrematch.length > 0) {
        dispatch(getEventScores(liveEventsInPrematch));
      }
    }

    callback?.(true);

  } catch (e) {
    logError(e);

    dispatch({
      type: GET_SPORTSBOOK_EVENTS_HASH_FAILURE,
      payload: e.response?.data || errorMessage
    });

    callback?.(false);
  }
};


export const resetSportsBookEventsHash = () => async dispatch => {
  dispatch({
    type: REST_SPORTSBOOK_EVENTS_HASH,
  });
};
